const typeModel = () => {
    return {
        teamMembers : [
            {
                type: 'LegalRepresentative'
            },
            {
                type: 'LegalRepresentative'
            },
            {
                type: 'Family'
            },
            {
                type: 'Family'
            }
        ],
        contacts: [
            {
                type: 'ResidentialProvider'
            },
            {
                type: 'ResidentialContact'
            },
            {
                type: 'ResidentialContact'
            },
            {
                type: 'PrimaryEmergency'
            },
            {
                type: 'SecondaryEmergency'
            },
            {
                type: 'PreferredHospital'
            },
            {
                type: 'HealthCareProvider'
            },
            {
                type: 'Dentist'
            },
            {
                type: 'PsychologistPsychiatrist'
            },
            {
                type: 'OtherHealthCare'
            }
        ]
    };
};

export default typeModel;
